import { apiPesquisaSatisfacao } from '@/plugins/axios'

export default {
  postConfig(data) {
    return apiPesquisaSatisfacao().post('/whatsappConfig', data)
  },
  getConfig() {
    return apiPesquisaSatisfacao().get('/whatsappConfig')
  },
}


